import { createDirectLine, createStore } from 'botframework-webchat'

export interface ActionHistory {
  actionId: string
  actionName: string
  actionOptions: Record<string, string | number | object>
  isEditableAction: boolean
}

export type UserActivityHistory = Map<string, ActionHistory | undefined>

export type DirectLineActivity = {
  text?: string
  channelData?: Record<string, unknown>
}

export type BotConnection = ReturnType<typeof createDirectLine>
export type BotFrameworkStore = ReturnType<typeof createStore>

export interface WebchatRuntime {
  botConnection: BotConnection | undefined
  store: BotFrameworkStore | undefined
  userActivityHistory: UserActivityHistory
}

const listeners = new Set<() => void>()

let runtime: WebchatRuntime = {
  botConnection: undefined,
  store: undefined,
  userActivityHistory: new Map(),
}

const notify = () => {
  listeners.forEach(listener => listener())
}

export const getWebchatRuntime = (): WebchatRuntime => runtime

export const subscribeWebchatRuntime = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const replaceRuntime = (next: WebchatRuntime) => {
  runtime = next
  notify()
}

export const setWebchatBotConnection = (botConnection: BotConnection | undefined) => {
  replaceRuntime({ ...runtime, botConnection })
}

export const setWebchatBotStore = (store: BotFrameworkStore | undefined) => {
  replaceRuntime({ ...runtime, store })
}

export const setUserActivityHistoryEntry = (
  id: string,
  payload: ActionHistory | undefined,
) => {
  const userActivityHistory = new Map(runtime.userActivityHistory)
  userActivityHistory.set(id, payload)
  replaceRuntime({ ...runtime, userActivityHistory })
}

export const clearWebchatRuntime = () => {
  replaceRuntime({
    botConnection: undefined,
    store: undefined,
    userActivityHistory: runtime.userActivityHistory,
  })
}

export const resetWebchatRuntime = () => {
  replaceRuntime({
    botConnection: undefined,
    store: undefined,
    userActivityHistory: new Map(),
  })
}
